"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledParagraph = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setFontStyle = weight => {
  switch (weight) {
    case 'normal':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        bold: false
      })}
      `;
    case 'bold':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        headline: true
      })}
      `;
    case 'deville':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        display: true
      })};
        letter-spacing: 0.012em;
      `;
    case 'univers-rounded-light':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        rounded: true,
        type: 'univers-rounded-light'
      })};
      `;
    case 'univers-rounded-roman':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        rounded: true,
        type: 'univers-rounded-roman'
      })};
      `;
    case 'univers-rounded-black':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        rounded: true,
        type: 'univers-rounded-black'
      })};
      `;
    default:
      return (0, _styledComponents.css)`
        font-family: 'univers-black', sans-serif;
      `;
  }
};
const StyledParagraph = _styledComponents.default.p`
  ${(0, _typography.setFontSizes)({
  xs: '18px',
  lg: '19px',
  xl: '19px'
})}
  line-height: 170%;
  color: ${props => props.fontColor || 'inherit'};
  text-align: ${props => props.textAlignment || 'left'};
  a {
    text-decoration: underline;
    text-decoration: none !important;
    color: ${props => props.fontColor || 'inherit'};
    border-bottom: 1px solid ${props => props.fontColor || 'inherit'};
    transition: 0.15s all;

    &:hover {
      opacity: 0.75;
    }
  }
  ${props => (0, _layout.setContainer)({
  size: props.lineWidth === 'wide' ? 'xl' : 'sm'
})};
  ${props => setFontStyle(props.fontStyle)};
`;
exports.StyledParagraph = StyledParagraph;
//# sourceMappingURL=styles.js.map